// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"EJ-z","carouselContainer":"FJ-z"};